import Delivery from './delivery';

export default Delivery;
